import i18n from '@/lib/i18n';
import { createPostalCodeRefinement } from '@/services/api/mainstream';
import type { PersonalInformation } from '..';

const { refinement, params } = createPostalCodeRefinement<Partial<Pick<PersonalInformation, 'countryOfResidency' | 'postCode'>>>({
  getParts: (data) => ({ country: data?.countryOfResidency, postCode: data?.postCode }),
  message: i18n.t('personalInformation.errors.postCode'),
  path: ['postCode'],
});

export const postalCodeRefinement = refinement;

export const postalCodeRefinementParams = params;
